<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M22.5 13a1.5 1.5 0 00-1.5 1.5v35a1.5 1.5 0 003 0v-35a1.5 1.5 0 00-1.5-1.5zM41.5 13a1.5 1.5 0 00-1.5 1.5v35a1.5 1.5 0 003 0v-35a1.5 1.5 0 00-1.5-1.5z"/></svg>